module.exports = __webpack_public_path__ + "img/googleQR.6d200ea2.png";